import {
	GET_INVITES,
	GET_INVITES_SUCCESS,
	GET_INVITES_FAILURE,
	SEND_INVITE,
	SEND_INVITE_SUCCESS,
	SEND_INVITE_FAILURE,
	APPROVE_INVITE,
} from './types';

export const getInvitesAction = () => ({
	type: GET_INVITES,
});

export const getInvitesSuccessAction = (payload: any) => ({
	type: GET_INVITES_SUCCESS,
	payload,
});

export const getInvitesFailureAction = (error: Error) => ({
	type: GET_INVITES_FAILURE,
	payload: error,
});

export const sendInviteAction = (payload: any) => ({
	type: SEND_INVITE,
	payload,
});

export const sendInviteSuccessAction = () => ({
	type: SEND_INVITE_SUCCESS,
});

export const sendInviteFailureAction = (error: Error) => ({
	type: SEND_INVITE_FAILURE,
	payload: error,
});

export const approveInviteAction = (payload: any) => ({
	type: APPROVE_INVITE,
	payload,
});
